<template>
  <el-dialog
    append-to-body
    width="500px"
    title="导入供应商采购价"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    @open="handleOpen"
    center
  >
    <el-form
      ref="elFormDom"
      label-position="right"
      label-width="100px"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
      class="center-form"
    >
      <el-form-item label="供应商:" prop="supplier_id" class="center-item">
        <el-select
          v-model="form.data.supplier_id"
          filterable
          @change="handleSupplierSelect"
          id="bind_id"
          clearable
          placeholder="请输入"
        >
          <el-option
            v-for="item in supplierArr"
            :label="item.name"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="锁价期限:" prop="lock_date" class="center-item">
        <el-date-picker
          v-model="form.data.lock_date"
          type="daterange"
          align="right"
          :disabled="getLockDateDisabled()"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          class="selDaterangeWidth"
          :clearable="false"
          id="date"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="上传文件:"
        prop="file"
        class="center-item forPosition"
      >
        <el-upload
          class="upload-demo"
          action=""
          :limit="1"
          :headers="{ token: token }"
          :on-remove="handleRemove"
          :http-request="httpRequestBack"
          :file-list="fileList"
          accept=".xlsx, .xls "
        >
          <el-button size="small" type="primary" plain>点击上传</el-button>
        </el-upload>
        <el-button
          type="text"
          class="down-excle"
          @click="download(exapleExcel, '导入供应商采购价样表.xlsx')"
          >下载样表</el-button
        >
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
    <el-dialog
      title="提示"
      append-to-body
      :visible.sync="tipVisible"
      width="30%"
      :before-close="tipClose"
    >
      <div>导入成功{{ sussessNum }}条，失败{{ failNum }}条。</div>
      <div v-if="tipList.length">以下为失败原因</div>
      <template>
        <div v-for="(item, index) in tipList" :key="index">{{ item }}</div>
      </template>
      <template #footer>
        <el-row type="flex" justify="center">
          <el-button type="primary" @click="tipClose">确定</el-button>
        </el-row>
      </template>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { getStorage } from "@/storage";
export default {
  props: ["supplierArr", "exapleExcel"],
  data() {
    return {
      token: getStorage("token"),
      visible: false,
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      form: {
        loading: false,
        data: {
          supplier_id: "",
          lock_date: [],
          file: "",
        },
        rules: {
          supplier_id: [
            {
              required: true,
              message: "请选择供应商",
              trigger: "change",
            },
          ],
          lock_date: [
            {
              type: "array",
              required: true,
              message: "请选择锁价期限",
              trigger: "change",
            },
          ],
          file: [
            {
              required: true,
              message: "请上传文件",
              trigger: "change",
            },
          ],
        },
      },
      fileList: [],
      tipVisible: false,
      tipList: [],
      sussessNum: 0,
      failNum: 0,
      supplierArrLock: [],
    };
  },
  methods: {
    //用于查锁价的供应商枚举
    getLockSupplier() {
      this.$http
        .get("/admin/lock/list", {
          params: { status: 1, page: 1, count: 10000 },
        })
        .then((res) => {
          if (res.code == 1) {
            this.supplierArrLock = res.data.list;
          }
        });
    },
    handleSupplierSelect(val) {
      let obj = this.supplierArrLock.find((item) => item.id === val);
      if (obj) {
        this.form.data.lock_date = [obj.lock_start, obj.lock_end];
      } else {
        this.form.data.lock_date = [];
        this.$nextTick(() =>{
          this.$refs.elFormDom.clearValidate("lock_date");
        })
      }
    },
    tipClose() {
      this.tipVisible = false;
      this.$emit("confirm");
      this.toggle(false);
    },
    reset(done) {
      this.currentRow = null;
      this.form.data = {
        supplier_id: "",
        lock_date: [],
        file: "",
      };
      this.fileList = [];
      done && done();
    },
    toggle(show) {
      this.visible = show;
      if (show) {
        this.getLockSupplier();
      }
      !show && this.reset();
    },
    close() {
      this.toggle(false);
    },
    handleOpen() {
      this.$nextTick(() => {
        this.$refs.elFormDom.clearValidate();
      });
    },
    getDetail(row) {
      this.currentRow = row;
      this.form.data.lock_date = [row.lock_start, row.lock_end];
    },
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          let formData = new FormData();
          formData.append("file", this.form.data.file);
          formData.append("lock_start", this.form.data.lock_date[0]);
          formData.append("lock_end", this.form.data.lock_date[1]);
          formData.append("supplier_id", this.form.data.supplier_id);
          this.form.loading = true;
          this.$http
            .post("/admin/lock/import", { formData, type: "upload" })
            .then((res) => {
              if (res.code === 1) {
                this.tipList = res.data.errors;
                this.sussessNum = res.data.success_count;
                this.failNum = res.data.fail_count;
                this.tipVisible = true;
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
    httpRequestBack(file) {
      this.form.data.file = file.file;
    },
    handleRemove(file, fileList) {
      this.form.data.file = "";
      this.fileList = [];
    },
    getLockDateDisabled() {
      let obj = this.supplierArrLock.find(
        (item) => item.id === this.form.data.supplier_id
      );
      // return Boolean(obj || !this.form.data.supplier_id);
      return false
    },
    download(urls, name) {
      const option = {
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      // If the browser supports fetch, use blob to download, so as to avoid the browser clicking the a tag and jumping to the preview of the new page
      if (window?.fetch) {
        fetch(urls, option)
          .then((res) => res.blob())
          .then((blob) => {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = name;
            a.click();
          });
      } else {
        const a = document.createElement("a");
        a.href = urls;
        a.target = "_blank";
        a.download = name;
        a.click();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.center-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.center-item {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.el-select,
.el-date-picker {
  width: 100%;
}
.forPosition {
  position: relative;
  .down-excle {
    position: absolute;
    right: 0px;
    top: 4px;
  }
}
</style>

